import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { IIframeSectionEntry } from '../../../../contentful/types/IIframeSection';
import { Section } from './Section';
import { Css, Iframe, Responsive } from '../../../../ui';
import { Color } from '../../../../styles/Color';

interface IIframeSectionProps {
	id: string;
	section: IIframeSectionEntry;
}

export function IframeSection({ id, section }: IIframeSectionProps) {
	return (
		<Section id={id}>
			<StyledIframe
				url={section.fields.url}
				maxWidth={section.fields.width}
				maxHeight={section.fields.height}
				title={section.fields.title}
				withBorder={section.fields.addBorder}
			/>
		</Section>
	);
}

const StyledIframe = styled(Iframe)<{ withBorder?: boolean }>`
	border-radius: 8px;

	${({ withBorder }) =>
		withBorder &&
		css`
			border: ${Css.pxToRem(24)} solid ${Color.Neutral1};
			outline: 1px solid ${Color.BorderCard};
			border-radius: 16px;

			@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
				border: 1px solid ${Color.BorderCard};
				border-radius: 8px;
			}
		`};
`;
